import { useMemo, useState } from "react";
import { Page } from "../../../helbest";
import styles from "./Appointment.module.css";
import { useTranslation } from "react-i18next";
import Tabs from "../../components/Tabs/Tabs";
import ServicesTab from "./ServicesTab/ServicesTab";
import AppointmentTab from "./AppointmentTab/AppointmentTab";
import { useSearchParams } from "react-router-dom";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";

const TAB_KEYS = {
  appointment: "APPOINTMENT",
  services: "SERVICES",
};

const Appointment = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || TAB_KEYS.appointment;
  const { t } = useTranslation();

  const TABS = useMemo(
    () => [
      { id: 0, label: t("drawer.appointments"), key: TAB_KEYS.appointment },
      { id: 1, label: t("drawer.services"), key: TAB_KEYS.services },
    ],
    []
  );

  return (
    <Page
      bodyWrapperClassName={styles.AppointmentPage}
      footer={<></>}
      customHeader={<HeaderBack url={"/"} title={t("common.appointment")} />}
      headerFix
      showFooter={false}
    >
      <div className={styles.tabsContainer}>
        <Tabs
          tabs={TABS}
          activeTab={tab}
          setActiveTab={(tab) =>
            setSearchParams(
              (prev) => {
                prev.set("tab", tab);
                return prev;
              },
              {
                replace: true,
              }
            )
          }
        />
      </div>
      {tab === TAB_KEYS.appointment ? <AppointmentTab /> : <ServicesTab />}
    </Page>
  );
};

export default Appointment;
